import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SurveyService } from '../service/survey.service';
import { UtilityService } from 'src/app/service/utility.service';


@Component({
  selector: 'app-target-group',
  templateUrl: './target-group.component.html',
  styleUrls: ['./target-group.component.scss']
})
export class TargetGroupComponent implements OnInit {
  public tGroup:any = [];
  public suvDetails: any = {};
  // public showAllContainers: any = ['All','Container-1 (Active)','Container-2 (Inactive)','Container-3 (Expired)','Container-4 (Active)'];
  public containerHoverIndex = -1;
  constructor(
    public surveyService:SurveyService,
    public route:Router,
    public activeRoute:ActivatedRoute,
    private cd: ChangeDetectorRef,
    public utility:UtilityService,

  ) { }

  ngOnInit(): void {
    // this.setFormFields();
    this.checkRedirectFrom();
    this.getSurvayDetails();
    this.getTgQuotaDetails();
    // this.selectedContainer();

    

    // console.log(this.surveyService.surveyReport,'Hiiiiiiii');
  }
  ngOnDestroy(): void{
    this.surveyService.defaultSurveyGetLink = 1;
  }

  checkRedirectFrom(){
    if(localStorage.getItem('redirectFromCompletionSurveyDetails')){
      this.surveyService.redirectFromCompletion = true;
      this.surveyService.redirectFromInventory = false;
      let surveyDeatils:any = localStorage.getItem('redirectFromCompletionSurveyDetails');
      surveyDeatils = JSON.parse(surveyDeatils);
      this.surveyService.redirectFromCompletionSurveyDetails = surveyDeatils;
      // this.surveyService.selected_container = surveyDeatils.selected_container;
    }
    else
    {
      this.surveyService.redirectFromCompletion = false;
      this.surveyService.redirectFromInventory = true;
      this.surveyService.selected_container = {'container_name':'Container All','status':'Active','container_id':''};
    }
  }

  getTgQuotaDetails(){
    let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id") || '';
    let container_id = "";
    if(localStorage.getItem('selected_container')){
      let selected_container:any = localStorage.getItem('selected_container');
      selected_container = JSON.parse(selected_container);
      this.surveyService.selected_container =selected_container;
      container_id = selected_container.container_id;
    }
    this.surveyService.getTgQuotaDetails(survey_id,container_id)
    .subscribe({
      next: (res: any) =>{
        if (res['status'] == 1) {
          this.tGroup = [];
          this.tgQuotaDetailsSet(res['result']);
          this.cd.detectChanges();
        }
      },error :(e) =>{
        console.log(e)
      }
    })
  }
  tgQuotaDetailsSet(res:any){
    Object.keys(res).forEach((va:any) =>
    {
      this.tGroup.push({name:va,key:va,value:res[va].join(" , ")});
      // let arr = res[va].join(",");
      // console.log(va,res[va],arr,'Result');

    })

  }


  setFormFields() {
    this.tGroup = [
      {name:'City',key:'city',value:"Delhi NCR"},
      {name:'Gender',key:'gender',value:"Male"},
      {name:'Age',key:'age',value:"24"},
    ]
  }
  detailsRouterChange(){
    let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
    // console.log(survey_id,'sURVEYiD');
    this.route.navigate([`/survey/details/${survey_id}`]);
  }
  quotaRouterChange(){
    let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
    // console.log(survey_id);
    this.route.navigate([`/survey/quota/${survey_id}`]);
  }
  tgQuotaRouterChange(){
    let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
    // console.log(survey_id);
    this.route.navigate([`/survey/target-group/${survey_id}`]);
  }
  // uploadRejectionRouterChange(){
  //   let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
  //   this.route.navigate([`/survey/operations/${survey_id}`]);
  // }

  getSurvayDetails(){
    if(!Object.keys(this.surveyService.surveyDetails).length)
    {
      let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id") || '';
      let container_id = "";
      if(localStorage.getItem('selected_container')){
        let selected_container:any = localStorage.getItem('selected_container');
        selected_container = JSON.parse(selected_container);
        this.surveyService.selected_container =selected_container;
        container_id = selected_container.container_id;
      }
      this.surveyService.getSurvayDetails(survey_id,container_id)
      .subscribe({
        next: (res: any) =>{
          if (res['status'] == 1) {
            this.suvDetails = res.result;
            this.suvDetails['total_sample_size'] =( res.result.achieved_sample || '-') + "/" + (res.result.sample_size || '-');
            this.suvDetails['crownit_sample_size'] = ( res.result.crownit_achieved_sample || '0') + "/" + (res.result.crownit_sample_size	 || '0');
            this.surveyService.surveyDetails = this.suvDetails;
            this.surveyService.setContainers(this.suvDetails);
            this.surveyService.selectedContainer();
            this.cd.detectChanges();
          }
        },error :(e) =>{
          console.log(e)
        }
      })
    }
    else
    {
      this.suvDetails = this.surveyService.surveyDetails;
    }

  }

  getLinkDetails(flag:number){
    if(flag === 0)
    {
      let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id") || '';
      this.surveyService.getDownloadLinkDetails(survey_id,1)
      .subscribe({
        next: (res: any) =>{
          if (res['status'] == 1) {
            this.surveyService.SurveyGetLink = res['links'];
            this.cd.detectChanges();
            this.utility.copyOnClick(res['links'][0]);
  
          }
        },error :(e) =>{
          console.log(e)
        }
      })
    }
    else
    {
      let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id") || '';
      this.surveyService.getDownloadLinkDetails(survey_id,this.surveyService.defaultSurveyGetLink)
      .subscribe({
        next: (res: any) =>{
          if (res['status'] == 1) {
            this.surveyService.SurveyGetLink = res['links'];
            this.cd.detectChanges();
            // this.utility.copyOnClick(res['links'][0]);
            this.surveyService.downloadLink(res['links']);

  
          }
        },error :(e) =>{
          console.log(e)
        }
      })

    }
   
  }

  getTestLinkDetails(link:any){
    this.utility.copyOnClick(link)
  }


  changeContainerBgColor(index:any){
    this.containerHoverIndex = index;
   
  }



  switchContainerCall(item:any){
    this.surveyService.selected_container = item;
    localStorage.setItem('selected_container',JSON.stringify(item));
    this.surveyService.surveyDetails = {};
    this.getSurvayDetails();
    this.getTgQuotaDetails();
  }

 
 

}
